import { LocalDate } from '@js-joda/core';
import { Observable } from 'rxjs';

import {
  ActivityItem, Branding, ChannelYouTubeInfo, ConfigurationState, DiningLocation, MealItem, NewsItem, PriorityNewsItem,
  ScheduledActivity, ServiceTypeItem, WeatherResponse
} from '../../shared/interfaces';
import { MailFeedModel } from '../../shared/models/mail';
import { ChannelContextModel } from '../config/models';
import { SignageChangeModel } from './models';

// The library's only door outward, host-supplied, so the runtime itself holds no URLs, auth or transport.
export abstract class SignageDataSource {
  // Optional: a preview host already holds the channel and passes it in rather than fetching it.
  public loadConfiguration?(signal: AbortSignal): Promise<ConfigurationState>;
  public abstract loadBranding(signal: AbortSignal): Promise<Branding>;
  public abstract loadServiceNames(signal: AbortSignal): Promise<ServiceTypeItem[]>;
  public abstract loadNews(context: ChannelContextModel, signal: AbortSignal): Promise<NewsItem[]>;
  public abstract loadBirthdays(context: ChannelContextModel, signal: AbortSignal): Promise<NewsItem[]>;
  public abstract loadPriorityNews(context: ChannelContextModel, signal: AbortSignal): Promise<PriorityNewsItem[]>;
  public abstract loadActivities(context: ChannelContextModel, on: LocalDate, signal: AbortSignal): Promise<ActivityItem[]>;
  public abstract loadScheduledVideos(context: ChannelContextModel, signal: AbortSignal): Promise<ScheduledActivity[]>;
  public abstract loadDiningLocations(context: ChannelContextModel, signal: AbortSignal): Promise<DiningLocation[]>;
  public abstract loadMeals(context: ChannelContextModel, on: LocalDate, signal: AbortSignal): Promise<MealItem[]>;
  public abstract loadWeather(signal: AbortSignal): Promise<WeatherResponse>;
  public abstract loadMail(signal: AbortSignal): Promise<MailFeedModel>;
  public abstract loadLiveVideo(context: ChannelContextModel, signal: AbortSignal): Promise<ChannelYouTubeInfo>;
  public abstract changes(context: ChannelContextModel): Observable<SignageChangeModel>;
}
